import React, {Component} from 'react';
import {withRouter} from 'react-router';
import {Search} from 'semantic-ui-react';

import {searchForSite} from '../data/search';

class SearchBox extends Component {

	componentWillMount() {
		this.resetComponent();
	}

	handleResultSelect = (event, result) => {
		this.setState({value: result.modem_name});
    const url = '/site/' + encodeURIComponent(this.state.id2object[result.id].modem_name)
		this.props.router.push(url);
  }

	handleSearchChanges = (event, value) => {

		this.setState({value: value});

		if (value.length < 1) return this.resetComponent();

		this.setState({isLoading: true});
		searchForSite(value).then((results) => {
      var id_to_object = {}
      var counter = 0;
			results = results.map( (result) => {
        var id = counter ++;
        id_to_object[id] = result;
				return {
					'id': id,
					'title': result.modem_name,
					'description': result.network + ' ' + result.satellite,
				};
			});
			this.setState({isLoading: false,  results: results, id2object: id_to_object});
		});	
	}

	resetComponent = () => this.setState({isLoading: false, results: [], value: '', id2object: {}})

  render() {
		const {isLoading, results, value} = this.state;
    return (
     	<Search 
				loading={isLoading}
				results={results}
				onSearchChange={this.handleSearchChanges}
				onResultSelect={this.handleResultSelect}
				value={value}
			/>
    );
  }

}
export default withRouter(SearchBox);



// WEBPACK FOOTER //
// ./src/components/SearchBox.js